import type { BasedFunctionConfig } from '@based/sdk/functions'

export const TENANT_URL = `tenants/steunpunt-amsterdam`

const config: BasedFunctionConfig = {
  type: 'app',
  name: TENANT_URL,
  public: true,
  main: './client.tsx',
  path: `/${TENANT_URL}/:path*`,
  favicon: './favicon.svg',
}

export default config
